/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_RetryInputs */

const th_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลองอีกครั้ง`)
};

const en_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const ja_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行`)
};

const zh_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const es_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar`)
};

const pt_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar de novo`)
};

const id_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba lagi`)
};

const fr_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const tl_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subukang muli`)
};

const vi_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

const ko_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 시도`)
};

const de_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const ru_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробовать снова`)
};

const tr_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden dene`)
};

const it_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprova`)
};

const pl_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spróbuj ponownie`)
};

const uk_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спробувати ще раз`)
};

const hi_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिर कोशिश करें`)
};

const ar_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة المحاولة`)
};

const ms_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuba lagi`)
};

const bn_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আবার চেষ্টা করুন`)
};

const zh_tw2_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重試`)
};

const zh_hk2_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重試`)
};

const ur_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دوبارہ کوشش کریں`)
};

const fa_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تلاش دوباره`)
};

const sw_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaribu tena`)
};

const nl_push_retry = /** @type {(inputs: Push_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw proberen`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Push_RetryInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_retry = /** @type {((inputs?: Push_RetryInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_RetryInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_retry(inputs)
	if (locale === "ja") return ja_push_retry(inputs)
	if (locale === "zh") return zh_push_retry(inputs)
	if (locale === "es") return es_push_retry(inputs)
	if (locale === "pt") return pt_push_retry(inputs)
	if (locale === "id") return id_push_retry(inputs)
	if (locale === "fr") return fr_push_retry(inputs)
	if (locale === "tl") return tl_push_retry(inputs)
	if (locale === "vi") return vi_push_retry(inputs)
	if (locale === "ko") return ko_push_retry(inputs)
	if (locale === "de") return de_push_retry(inputs)
	if (locale === "ru") return ru_push_retry(inputs)
	if (locale === "tr") return tr_push_retry(inputs)
	if (locale === "it") return it_push_retry(inputs)
	if (locale === "pl") return pl_push_retry(inputs)
	if (locale === "uk") return uk_push_retry(inputs)
	if (locale === "hi") return hi_push_retry(inputs)
	if (locale === "ar") return ar_push_retry(inputs)
	if (locale === "ms") return ms_push_retry(inputs)
	if (locale === "bn") return bn_push_retry(inputs)
	if (locale === "zh-TW") return zh_tw2_push_retry(inputs)
	if (locale === "zh-HK") return zh_hk2_push_retry(inputs)
	if (locale === "ur") return ur_push_retry(inputs)
	if (locale === "fa") return fa_push_retry(inputs)
	if (locale === "sw") return sw_push_retry(inputs)
	if (locale === "nl") return nl_push_retry(inputs)
	return en_push_retry(inputs)
});